import useApi from "../../api/useApi";

const useInvoiceService = () => {

  const { apiBlob } = useApi();

  const streamPdf = async (endpoint, id) => {
    try {
      const response = await apiBlob("get", `${endpoint}/${id}`);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      const message = error.response?.data || error.message || JSON.stringify(error);
      throw new Error(`Error in streamPdf (${endpoint}): ${message}`);
    }
  };

  return {
    objectType: "invoice",
    handleStreamInvoicePdf: (invoiceId) => streamPdf("user/invoice/stream-pdf", invoiceId),
    handleStreamReceiptPdf: (receiptId) => streamPdf("user/receipt/stream-pdf", receiptId),
    handleStreamBookingInvoicePdf: (bookingId) =>
      streamPdf("user/invoice/stream-pdf/booking", bookingId),
    handleStreamBookingReceiptPdf: (bookingId) =>
      streamPdf("user/receipt/stream-pdf/booking", bookingId),
  };
}

export default useInvoiceService
